// src/config/hazardVisibility.js
export const HAZARD_VISIBILITY = {
  Routine: false,
  Flooding: false,
  Hurricane: false,
  "Severe Storms": false,
  Tornado: false,              // hide for now
  Wildfire: false,
  "Winter Weather": true,
  "Extreme Heat": false,
  "Extreme Cold": false,
  "High Winds": false,
  "Dense Fog": false,
  "Surf & Rip Currents": false,
};
